export default "__VITE_ASSET__BZ6Fm4$K__"